import { styled, css } from "styled-components";

export const ProductLabelImage = styled.img<{ $larger?: boolean }>`
  display: inline-block;
  position: absolute;
  left: -${(props) => props.theme.spacing.m};
  top: -${(props) => props.theme.spacing.m};
  width: 90px;
  height: 90px;

  ${(props) =>
    props.$larger &&
    css`
      width: 120px;
      height: 120px;
      left: -${(props) => props.theme.spacing.l};
      top: -${(props) => props.theme.spacing.l};
    `}
`;
